/*
Sohel 10/29/2023 5314488544 Fixed Reset and Data Mapping Issue.
Sohel 10/29/2023 5314488544 formated Date data MMDDYYYY
Sohel 10/30/2023 5314488544 Accordion issue fix in table
Guru Prasad 10/30/2023 5314488544 Fixed Accordion overlapping issue
Sohel 10/30/2023 5314488544 Accordion changes for the table
Sohel 10/30/2023 5314488544 data format issue fixed
Sohel 10/30/2023 5314488544 changes in Reviewed details button kept in accordion 
Sohel 10/30/2023 5314488544 reviewed details button UI fixed
Sohel 10/30/2023 5314488544 Added eligibiltySummary 
Sohel 10/30/2023 5314488544 reseting the notes table data
Sohel 11/01/2023 5314488544 new MUI table Implemented table data
Guru Prasad 01/11/2023 5314488544 Added classnames for mui collapse table 
Sohel 01/11/2023 5314488544 Added conditionaly table 
Sohel 01/11/2023  5314488544 Added table pagination and removed unwanted data
sohel 06/11/2023 5314488544 account status table api call 
sohel 11/10/2023 5314488544 table pagination bug fix
*/
import React, { useState, useEffect } from 'react';
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  makeStyles,
  useTheme,
} from '@material-ui/core';
import { useLocation } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import EligibiltyNotes from './EligibiltyNotes';
import DialogBox from '../../../components/DialogBox';
import {
  fetchEligibleScrubAllData,
  resetEligibleNotesTableData,
  resetEligibleScrub,
} from '../../../redux/reducers/EligibiltyScrubs';
import CustomTableMUI from './CustomTableMUI';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import LastPageIcon from '@material-ui/icons/LastPage';

export default function EligibilityScrubAndPronto() {
  const dispatch = useDispatch();
  const { eligibleScrubAllData } = useSelector(({ eligibleScrub }) => eligibleScrub);
  const location = useLocation();
  const accountNumber = location?.state?.accountNumber;
  const [openNote, setOpenNote] = useState(false);
  const [eligibilitySummaryId, setEligibilitySummaryId] = useState('');
  useEffect(() => {
    if (accountNumber) {
      dispatch(fetchEligibleScrubAllData(accountNumber));
    }
  }, [accountNumber]);
  useEffect(() => {
    dispatch(resetEligibleScrub());
  }, []);
  const handleDialogClose = () => {
    setOpenNote(false);
    setEligibilitySummaryId('');
    dispatch(resetEligibleNotesTableData());
  };
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const indexOfLastRow = (page + 1) * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = eligibleScrubAllData?.slice(indexOfFirstRow, indexOfLastRow);
  const useStyles1 = makeStyles((theme) => ({
    root: {
      flexShrink: 0,
      marginLeft: theme.spacing(2.5),
    },
  }));

  function CustomTablePagination(props) {
    const classes = useStyles1();
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <div className={classes.root}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    );
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value, 10);
    setPage(0);
  };
  return (
    <>
      <DialogBox
        open={openNote}
        dialogClose={handleDialogClose}
        title="Review Details"
        maxWidth="lg"
      >
        <EligibiltyNotes
          eligibilitySummaryId={eligibilitySummaryId}
          accountNumber={accountNumber}
        />
      </DialogBox>
      <Grid item xs={12} className='mt-3'>
        <TableContainer component={Paper} className="mui-collapse-table new-standard-textfields">
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>{'Eligibility Vendor'}</TableCell>
                <TableCell>{'Sent Date'}</TableCell>
                <TableCell>{'Service Date'}</TableCell>
                <TableCell>{'Response Date'}</TableCell>
                <TableCell>{'Outcome Category'}</TableCell>
                <TableCell>{'Outcome'}</TableCell>
                <TableCell>{'Reviewed Date'}</TableCell>
                <TableCell>{'Reviewed By'}</TableCell>
                <TableCell>{'Reviewed Status'}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {eligibleScrubAllData.length > 0 ? (
                currentRows?.map((row) => (
                  <CustomTableMUI
                    key={row.name}
                    row={row}
                    setOpenNote={setOpenNote}
                    openNote={openNote}
                    setEligibilitySummaryId={setEligibilitySummaryId}
                  />
                ))
              ) : (
                <TableRow>
                  <TableCell className="text-center" colSpan={10}>
                    No Records To Display
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 20]}
                  colSpan={10}
                  count={eligibleScrubAllData.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  SelectProps={{
                    inputProps: { 'aria-label': 'rows per page' },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  ActionsComponent={CustomTablePagination}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Grid>
    </>
  );
}
